import { Modal } from "@twinkltech/curriculum-architect-component-library";

import { BatchUpdateTableStructuresPayload } from "@/states/unitTableReducer/unitTableReducer";

import {
  PlannerSettingsModal,
  type TableHeaders,
} from "./PlannerSettingsModal";

export const PlannerSettingsModalContainer = ({
  columnHeaders,
  onApply,
  onClose,
  rowHeaders,
  ...props
}: {
  columnHeaders: TableHeaders[];
  onApply: (data: BatchUpdateTableStructuresPayload) => void;
  rowHeaders: TableHeaders[];
} & Omit<React.ComponentProps<typeof Modal>, "children">) => {
  return (
    <PlannerSettingsModal
      columnHeaders={columnHeaders}
      rowHeaders={rowHeaders}
      onApply={onApply}
      onClose={onClose}
      {...props}
    />
  );
};
